import React from "react";
import { getBasketTotal } from "./reducer";
import CurrencyFormat from "react-currency-format";
import { useStateValue } from "./StateProvider";
import "./Subtotal.css";

function Subtotal() {
  const [{ basket }] = useStateValue();

  return (
    <div className="subtotal">
      <CurrencyFormat
        renderText={(value) => (
          <>
            <p>
        {basket.length} item(s)
        <br/>
        <strong>{value}</strong>
            </p>
            <small className="subtotal__gift">
              <input type="checkbox" /> This order contains a gift
            </small>
          </>
        )}
        decimalScale={2}
        value={getBasketTotal(basket)}
        displayType={"text"}
        thousandSeparator={true}
        prefix={"R"}
      />
      <button>Proceed to Checkout</button>
      <p><i>Thanks for shopping at OnePageOnly</i> 🔥 </p>
    </div>
  );
}

export default Subtotal;